import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { isListed } from "./membership.js";
import { changeColumnDataTypeAction, changeColumnDomainAction } from "../table-column/atom.actions.js";
import { getDataTypeSyncColumns } from "../table-column/utils/dataType.js";
//#region src/engine/modules/dictionary/domainTypes.ts
var NO_DOMAIN_TYPES = /* @__PURE__ */ new Map();
function domainTypeIn(state, domainTypes) {
	const { domainEntities } = state.collections;
	return (id) => domainTypes.get(id) ?? domainEntities[id]?.dataType ?? "";
}
function readDomains(state, domainTypes, links) {
	const { collections, doc } = state;
	const columns = query(collections).collection("tableColumnEntities");
	const linkOf = new Map(links.map(({ id, value }) => [id, value]));
	return {
		columns,
		isLiveDomain: (id) => id !== "" && isListed(doc.domainIds, id),
		domainTypeOf: domainTypeIn(state, domainTypes),
		domainIdOf: (id) => linkOf.get(id) ?? columns.selectById(id)?.domainId ?? ""
	};
}
function toDomainUnlinkActions(state, written, { domainTypes = NO_DOMAIN_TYPES, links = [] } = {}) {
	const { domainTypeOf, domainIdOf } = readDomains(state, domainTypes, links);
	return written.filter(({ id, value }) => {
		const domainId = domainIdOf(id);
		return domainId !== "" && domainTypeOf(domainId) !== value;
	}).map(({ tableId, id }) => changeColumnDomainAction({
		tableId,
		id,
		value: ""
	}));
}
function toDomainTypeActions(state, { domainTypes = NO_DOMAIN_TYPES, links = [], dataTypes = [] }) {
	const { collections, doc, settings } = state;
	const sentLinks = links.filter(({ value }) => value === "" || isListed(doc.domainIds, value));
	const { columns, isLiveDomain, domainTypeOf, domainIdOf } = readDomains(state, domainTypes, sentLinks);
	const settled = /* @__PURE__ */ new Map();
	for (const payload of dataTypes) settled.set(payload.id, payload);
	for (const { tableId, id, value } of sentLinks) if (value !== "") settled.set(id, {
		tableId,
		id,
		value: domainTypeOf(value)
	});
	const changed = new Set([...domainTypes.keys()].filter(isLiveDomain));
	if (changed.size) {
		const tables = query(collections).collection("tableEntities").selectByIds(doc.tableIds);
		for (const table of tables) for (const id of table.columnIds) {
			const domainId = domainIdOf(id);
			if (!settled.has(id) && changed.has(domainId)) settled.set(id, {
				tableId: table.id,
				id,
				value: domainTypeOf(domainId)
			});
		}
	}
	const seeds = [...settled.values()];
	const payloads = settings.relationshipDataTypeSync ? getDataTypeSyncColumns([...seeds], state, [], void 0, new Set(settled.keys())) : seeds;
	const direct = new Set(dataTypes.map(({ id }) => id));
	const written = payloads.filter(({ id, value }) => direct.has(id) || columns.selectById(id)?.dataType !== value);
	const linkActions = sentLinks.filter(({ id, value }) => columns.selectById(id)?.domainId !== value).map(changeColumnDomainAction);
	const unlinkActions = toDomainUnlinkActions(state, written, {
		domainTypes,
		links: sentLinks
	});
	return [
		...linkActions,
		...written.map(changeColumnDataTypeAction),
		...unlinkActions
	];
}
//#endregion
export { domainTypeIn, toDomainTypeActions, toDomainUnlinkActions };
